// saga.js
import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_SHIFTS,
  ADD_SHIFTS,
  UPDATE_SHIFTS,
  DELETE_SHIFTS,
} from './actionTypes'
import {
  getShiftsSuccess,
  getShiftsFail,
  addShiftSuccess,
  addShiftFail,
  updateShiftSuccess,
  updateShiftFail,
  deleteShiftSuccess,
  deleteShiftFail,
  setShiftFieldErrors,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchShiftsApi = () => axiosInstance.get('', { params: { sp: 'usp_GetShifts' } })
const addShiftApi = (shift) => axiosInstance.post('', shift)
const updateShiftApi = (shift) => axiosInstance.post('', shift)
const deleteShiftApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteShift', shiftId: id })

// Sagas
function* getShiftsSaga() {
  try {
    const { data } = yield call(fetchShiftsApi)
    yield put(getShiftsSuccess(data))
  } catch (error) {
    yield put(getShiftsFail(error.response?.data || error.message))
  }
}

function* addShiftSaga(action) {
  try {
    const { data } = yield call(addShiftApi, action.payload)
    yield put(addShiftSuccess(data))
    toast.success('Shift added successfully!')
    yield put({ type: GET_SHIFTS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setShiftFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addShiftFail(error.response?.data || error.message))
    }
  }
}

function* updateShiftSaga(action) {
  try {
    const { data } = yield call(updateShiftApi, action.payload)
    yield put(updateShiftSuccess(data))
    toast.success('Shift updated successfully!')
    yield put({ type: GET_SHIFTS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setShiftFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateShiftFail(error.response?.data || error.message))
    }
  }
}

function* deleteShiftSaga(action) {
  try {
    yield call(deleteShiftApi, action.payload)
    yield put(deleteShiftSuccess(action.payload))
    toast.success('Shift deleted successfully!')
    yield put({ type: GET_SHIFTS })
  } catch (error) {
    yield put(deleteShiftFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* shiftSaga() {
  yield takeEvery(GET_SHIFTS, getShiftsSaga)
  yield takeEvery(ADD_SHIFTS, addShiftSaga)
  yield takeEvery(UPDATE_SHIFTS, updateShiftSaga)
  yield takeEvery(DELETE_SHIFTS, deleteShiftSaga)
}

export default shiftSaga
